import{DEVICE_FINGERPRINT as e,ERROR_MESSAGES as o,ERRORS as s}from"../../constants.js";const t=t=>({errorCode:t,message:o[t]||o[s.UNKNOWN],type:e});export{t as default};
